<template>
  <TablePortlet
    code="clientTripsPortlet"
    ref="portlet"
    title="Trechos criados recentemente"
    :fetcher="fetchData"
    :spec="spec"
    @rowClicked="showRowDetails"
  />
</template>

<script>
import { OrgApi } from '@/models'
import { dt, sDuration, brNum } from 'oderon-commons/src/formatters'
import TablePortlet from '../../../components/TablePortlet.vue'
import { isGreat, valid, invalid, great } from '../../vehicle/trip-columns.js'
import { preProcessSpec } from 'oderon-commons/src/tables'

export default {
  components: {
    TablePortlet
  },
  props: {
    client: { required: true }
  },
  data() {
    return {
      spec: preProcessSpec({
        defaultSortable: false,
        columns: [
          { t: 'ID|', d: 'id', w: 90 },
          {
            t: '||',
            code: 'ind',
            d: (row) => {
              if (!row.isValid) return invalid
              else if (isGreat(row)) return great
              else return valid
            },
            w: 40
          },
          {
            t: 'Início|',
            d: 'startTimestamp',
            w: 130,
            f: (x) => dt(x, 'DD/MMM/YYYY HH:mm')
          },
          { t: 'Motorista', d: 'driver.name' },
          {
            t: 'Duração|',
            d: 'durationS',
            w: 100,
            f: sDuration
          },
          { t: 'Dist.(m)|', d: 'distanceM', w: 100, f: brNum }
        ],
        rowClass: (r) => {
          return r.isOngoing ? 'blue lighten-4' : ''
        }
      })
    }
  },
  watch: {
    client() {
      this.$refs.portlet.reloadFromStart()
    }
  },
  methods: {
    async fetchData({ limit, offset } = {}) {
      let order = 'createdAt desc, id desc'
      let orgId = this.client.organizationId
      let vehicleId = this.client.vehicleId

      if (orgId == null || vehicleId == null) {
        return { count: 0, rows: [] }
      }

      let fetcher = new OrgApi(orgId)
      let data = await fetcher.get('trips', { vehicleId, limit, offset, order })
      return data
    },

    async showRowDetails({ row }) {
      let res = await this.$vis({
        tripId: row.id,
        orgId: this.client.organizationId
      })

      if (res === true) this.$emit('reload')
    }
  }
}
</script>

<style></style>
